export function clone<T>(any: T): T {
	if (any === null) return null;
	return JSON.parse(JSON.stringify(any));
}
